import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
  faArrowLeft,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { IconButton } from "../components/button/IconButton";
import logo from "../img/header_icon.svg";
import styles from "../pages/layout/Header/Header.module.scss";
import Header from "./layout/Header/Header";
export const AccessDenied = () => {
  return (
    <div className="access-wrapper">
      <Header showOnlyLogo={true} />
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="access-card">
          <div className="icon-wrapper">
            <FontAwesomeIcon icon={faLock} size="2x" />
          </div>

          <h1>Access Denied</h1>

          <p className="primary-text">
            You don’t have permission to view this page.
          </p>

          <p className="secondary-text">
            This may be because your role doesn’t include access or your session
            has expired. If you think this is a mistake, please contact your
            administrator.
          </p>
        </div>
      </div>

      <style>{css}</style>
    </div>
  );
};

const css = `
.access-wrapper {
width:100%;
height:100%;
    display:flex;
    flex-direction:column;
    background: #f8fafc;
}

.access-card {
    width: 100%;
    max-width: 480px;
    padding: 48px 40px;
    border-radius: 20px;
    text-align: center;
}

.icon-wrapper {
    margin: 0 auto 20px;
    border-radius: 50%;
    // background: #fee2e2;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #132445;
    font-size: 24px;
}

.access-card h1 {
    font-size: 28px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 12px;
}

.primary-text {
    font-size: 16px;
    color: #334155;
    margin-bottom: 8px;
}

.secondary-text {
    font-size: 14px;
    color: #64748b;
    line-height: 1.6;
}

.actions {
    display: flex;
    gap: 12px;
    margin-top: 32px;
    justify-content: center;
    flex-wrap: wrap;
}

.btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 18px;
    font-size: 14px;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    transition: all 0.25s ease;
}

.btn-primary {
    background: #2563eb;
    color: #ffffff;
}

.btn-primary:hover {
    background: #1d4ed8;
}

.btn-secondary {
    background: #f1f5f9;
    color: #334155;
}

.btn-secondary:hover {
    background: #e2e8f0;
}
`;
